import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { useSubscribeUser } from "../hooks/useSubscribeUser";
import { FaTimes } from "react-icons/fa";
import "./SubscribeModal.css";
import { v4 as uuidv4 } from "uuid";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";

const SubscribeModal = ({ showModal, handleClose }) => {
  const [cookies, setCookies, removeCookie] = useCookies();
  const { mutate, isLoading } = useMutation(useSubscribeUser, {
    onSuccess: (data) => {
      toast.success("Successfully subscribed");
      if (process.env.REACT_APP_IS_PRODUCTION !== "false") {
        setCookies("event_id", uuidv4());
        // eslint-disable-next-line no-undef
        fbq(
          "track",
          "Lead",
          {},
          {
            event_id: cookies["event_id"],
            external_id: JSON.parse(localStorage.getItem("utmParams"))
              ?.external_id,
          }
        );
      }
      handleClose();
    },
    onError: (error) => {
      toast.error(error?.response.data.error);
    },
  });

  const [isMarketingEmailsChecked, setIsMarketingEmailsChecked] =
    useState(false);
  const [isCheckboxError, setIsCheckboxError] = useState(false);

  const subscribe = (email, shouldReceiveMarketingEmails) => {
    if (!shouldReceiveMarketingEmails) {
      setIsCheckboxError(true);
    } else {
      mutate(email);
      setIsCheckboxError(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    subscribe(email, isMarketingEmailsChecked);
  };

  const handleMarketingEmailsCheckboxChange = () => {
    setIsMarketingEmailsChecked((prev) => !prev);
    setIsCheckboxError(false);
  };
  const {t} = useTranslation()

  return (
    <Modal show={showModal} onHide={handleClose} centered size="lg">
      <div className="custom-modal-container">
        <FaTimes onClick={handleClose} className="custom-close-button" />
        <div className="custom-form-container bg-white rounded-2 p-4">
          <h2>{t("newsletter.title")}</h2>
          <p className="text-dark">
          {t("newsletter.description")}
          </p>
          <Form
            className="mt-4 flex-column align-items-center"
            onSubmit={handleSubmit}
          >
            <Form.Group controlId="formBasicEmail" className="flex-grow mb-3">
              <Form.Control
                type="email"
                placeholder={t("subscription.email_placeholder")}

                name="email"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicCheckbox">
              <Form.Check
                type="checkbox"
                label={t("newsletter.marketingConsent")}
                checked={isMarketingEmailsChecked}
                onChange={handleMarketingEmailsCheckboxChange}
              />
              {isCheckboxError && (
                <p className="text-danger">
                  {t("subscription.marketing_error")}
                  </p>
              )}
            </Form.Group>

            <Button
              variant="carre-blue w-100"
              className=""
              type="submit"
              disabled={isLoading || isCheckboxError}
            >
   {isLoading
                      ? t("subscription.subscribing")
                      : t("subscription.subscribe_button")}       </Button>
          </Form>
        </div>
      </div>
    </Modal>
  );
};

export default SubscribeModal;
